"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helpers = void 0;
require("whatwg-fetch");
var Helpers = /** @class */ (function () {
    function Helpers() {
        var _this = this;
        this.context = null;
        this.shop = null;
        this.init = function (context, data) {
            _this.context = context;
            _this.shop = data.shop;
        };
        this.requestURL = function (url) {
            return "" + (window.location.href.includes("localhost")
                ? "https://app.developertoolkit.io/api/client"
                : "/apps/toolkit/client") + url + "?shop=" + _this.shop.domain;
        };
        this.getProducts = function (productsIds) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/helpers/products/" + productsIds), {
                                credentials: "same-origin",
                                method: "GET",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache"
                                }
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                _this.context.update({
                                    message: "HELPERS_PRODUCTS_SUCCESS"
                                });
                                return data;
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "HELPERS_PRODUCTS_FAILED",
                                error: err_1.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getGiftcard = function (code, customerId) { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/helpers/giftcards/" + code + "?customer_id=" + (customerId ? customerId : "")), {
                                credentials: "same-origin",
                                method: "GET",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache"
                                }
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                _this.context.update({
                                    message: "HELPERS_GIFTCARD_SUCCESS"
                                });
                                return data;
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "HELPERS_GIFTCARD_FAILED",
                                error: err_2.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.updateCustomer = function (customerId, body) { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/helpers/customer/" + customerId), {
                                credentials: "same-origin",
                                method: "POST",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache"
                                },
                                body: JSON.stringify(body)
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                _this.context.update({
                                    message: "HELPERS_CUSTOMER_SUCCESS"
                                });
                                return data;
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "HELPERS_CUSTOMER_FAILED",
                                error: err_3.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    return Helpers;
}());
exports.Helpers = Helpers;
//# sourceMappingURL=helpers.js.map